import React, { ReactNode } from "react";
import { Card } from "../common/Card";

interface ItemProps {
  icon: ReactNode;
  label: string;
  value: string | number;
}

interface InteractionsCardProps {
  icon: string;
  title: string;
  value: string | number;
  details?: {
    label: string;
    value: string | number;
    icon: any;
  }[];
  className?: string;
}

const InteractionsCard: React.FC<InteractionsCardProps> = ({
  icon,
  title,
  value,
  details = [],
  className = "",
}) => {
  return (
    <Card
      className={`p-6 rounded-[16px] border-[#EBEBEB] border-[1px] bg-[#FFF9F6] ${className}`}
      style={{
        boxShadow: "0px 4px 4px 0px #0000000A",
      }}
    >
      <div className="flex items-center gap-3">
        <div className="rounded-full p-4">
          <img src={icon} alt={title} />
        </div>
        <div className="flex-grow">
          <div>
            <div className="text-[32px] text-[#404040] nunito-bold">
              {value}
            </div>
            <div className="text-[#696969] text-[20px] nunito-regular mt-2">
              {title}
            </div>
          </div>
        </div>
        {details.length > 0 && (
          <div className="space-y-3">
            {details.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="flex items-center justify-between gap-4"
                >
                  <div className="flex items-center gap-2">
                    <Icon className=" w-[24px] h-[24px] text-[#F15D18] " />
                    <span className="text-[#696969] text-[14px] nunito-regular">
                      {item.label}
                    </span>
                  </div>
                  <span className="text-[#404040] text-[14px] nunito-bold">
                    {item.value}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Card>
  );
};

export default InteractionsCard;
